import React from 'react';
import { AdminLayout } from '@/components/Layout/Layout';
import SideBar from '@/components/SideBar/SideBar';
import api from '@/shared/api/api';
import { useFetch } from '@/shared/hooks/useFetch';
import { RecordField, TextField } from '@/shared/ui/Fields/Fields';
import { TestCaseListResponseDTO, TestCaseStatus } from '@/shared/api/gen/data-contracts';
import { DataGrid } from '@/components/DataGrid/DataGrid';
import { useNavigate, useParams } from 'react-router-dom';
import ProjectSidebar from './components/ProjectSidebar';


function ProjectArchivedCases() {
    const { projectID } = useParams();
    const navigate = useNavigate();

    const { data: testCases, refresh } = useFetch(
        // @ts-ignore
        () => api.test_cases.getTestcasesApiTestCasesGet({ project_ref: Number(projectID) }),
        [], [], { autoRefresh: false }
    );

    const archivedCases: TestCaseListResponseDTO[] = (testCases as TestCaseListResponseDTO[])?.filter(
        (tc) => tc.status === TestCaseStatus.DEPRICATED
    ) ?? [];

    const restoreCase = async (id: number) => {
        await api.test_cases.updateTestcaseStatusApiTestCasesIdStatusPatch(id, { status: TestCaseStatus.DRAFT });
        refresh();
    };

    return (
        <AdminLayout
            sidebarSlot={
                <SideBar>
                    <ProjectSidebar id={projectID} />
                </SideBar>
            }
        >
            <DataGrid title="Архив тест-кейсов" records={archivedCases}>
                <TextField key='id' label="ID" />
                <TextField key='title' label="Название" />
                <TextField key='priority' label="Приоритет" />
                <TextField key='tags' label="Теги" />
                <RecordField
                    label='Восстановить'
                    render={(record) => (
                        <div
                            className='text-14 cursor-pointer'
                            onClick={() => restoreCase(record?.id)}
                        >
                            Восстановить
                        </div>
                    )}
                />
                <RecordField
                    label='Редактировать'
                    render={(record) => (
                        <div
                            className='text-14 cursor-pointer red'
                            onClick={() => navigate(`/test_cases/update/${record?.id}`)}
                        >
                            Редактировать
                        </div>
                    )}
                />
            </DataGrid>
        </AdminLayout>
    );
}

export default ProjectArchivedCases;
